import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Badge } from "@tellescope/ui";
import { Bell, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export interface AppointmentReminderCardProps {
  template: TellescopeModelFromName<"calendar_event_templates">;
  onClick: (() => void) | { to: string; replace?: boolean };
}

export const AppointmentReminderCard = ({ template, onClick }: AppointmentReminderCardProps) => {
  const { t } = useTranslation("appointment-reminders");
  const Component = typeof onClick === "function" ? "button" : Link;

  return (
    <Component
      className="transition border rounded-md flex flex-col hover:bg-gray-100"
      to={typeof onClick === "object" ? onClick.to : ""}
      replace={typeof onClick === "object" ? onClick.replace : undefined}
      onClick={typeof onClick === "function" ? onClick : undefined}
    >
      <div className="p-3 space-y-2 grow">
        <span className="flex items-center gap-2">
          <p className="text-sm text-left">{template.title}</p>
        </span>
        <div className="text-muted-foreground space-y-2">
          {!!template.description && (
            <span className="flex items-start gap-1 text-xs truncate line-clamp-2">{template.description}</span>
          )}
          <span className="flex items-start gap-1 text-xs truncate line-clamp-2">
            <Clock size={15} />
            {t("{{count}} minutes", { count: template.durationInMinutes })}
          </span>
          <span className="flex items-start gap-1 text-xs truncate line-clamp-2">
            <Bell size={15} />
            {t("{{count}} reminders", { count: template.reminders?.length })}
          </span>
        </div>
      </div>
      <div className="px-4 bg-muted min-h-9 flex gap-2 items-center rounded-b-md">
        {template.tags?.length ? (
          template.tags?.map((tag) => (
            <Badge key={tag} variant="outline" className="bg-white rounded-full font-light text-muted-foreground h-min">
              {tag}
            </Badge>
          ))
        ) : (
          <p className="text-xs text-muted-foreground font-light italic">{t("No tags")}</p>
        )}
      </div>
    </Component>
  );
};
